
class IMC_COMMON {

    constructor() {
        this.css_info = "font-size: 16px;color:red;";
        this.css = "font-size: 40px;color:#5D9733; text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;text-align:center";

        console.log('%c IMC CORE INIT! ', this.css);
        console.log('%c ******* Loik Maksim Product ****** ', this.css);

    }

     showloading () {

        this.hideloading();
        jQuery('body').prepend
        (' <div id="loader-wrapper">' +
            '<div id="loader"></div>' +
            '<div class="loader-section section-left"></div>' +
            '<div class="loader-section section-right"></div>' +
            '</div>');
    }

     hideloading () {
        jQuery('.overlay').remove();
        jQuery('#loader-wrapper').remove();
    }

    snackbar(mes) {
        var x = document.getElementById("snackbar")
        jQuery('#snackbar').html(mes);
        x.className = "show_snack";
        setTimeout(function () {
            x.className = x.className.replace("show_snack", "");
        }, 3000);
    }


     message (mes, title = "IMC", params = {}) {
        EventBus.$emit('show_imc_modal',{
            title:title,
            html:mes,
            params : params
        });
    }

     closemes (delay) {
        if (delay == undefined) {
            delay = 2500;
        }
        EventBus.$emit('close_imc_modal',{delay:delay})
    }

}

export default IMC_COMMON;
